export default __webpack_public_path__ + "static/media/doc-detail.8d4fba3c.svg";